import { NOTIFICATION_TYPE } from '../../models/notification.constants'
import { useNotificationsQuery } from '../../services/useNotificationsQuery'

const hasIntentionNotificationTypes = new Set([
  NOTIFICATION_TYPE.INTENTION_FINISHED,
  NOTIFICATION_TYPE.BIRTHDAY_INTENTION_FINISHED,
  NOTIFICATION_TYPE.ARRIVAL_INTENTION_FINISHED,
  NOTIFICATION_TYPE.NEW_PRAYER_ON_INTENTION,
])

export const useHasIntentionNotifications = () => {
  const { data, isPending } = useNotificationsQuery()

  return !isPending && !!data?.some(({ type }) => hasIntentionNotificationTypes.has(type))
}
